import React, { useState, useReducer, createContext, useContext, useEffect } from 'react';
import { Select, Button, Table, Modal, Input, DatePicker, Switch, message, Cascader } from 'antd';
import "./index.less";
import { classifyList, classifyCheckList, websiteList, dealRelInfo, deleteBatch, queryCaseInfo, deleteCaseImg, styleList, desingerList } from "../../api";
import { useUpdate } from 'ahooks';
const { Option } = Select;
const { RangePicker } = DatePicker;
const Ctx = createContext();
const reg = /^\d+(\.\d+)?$/;
const initInfo = {
    firstClassifyChooseName: '',
    secondClassifyChooseName: '',
    firstClassifyChooseId: '',
    secondClassifyChooseId: '',
    caseId: '',
    headTitle: '',
    title: '',
    cover: '',
    classifyList: [],
    styleList: [],
    editorClassifyList: [],
    desingerList: []
}
const reducer = (state, action) => {
    return { ...state, ...action };
}

const recommendStatus = ['未处理', '已处理'];
const listStatusArr = [
    {
        type: '666',
        statusName: '全部',
    },
    {
        type: '0',
        statusName: '未处理',
    },
    {
        type: '1',
        statusName: '已处理',
    }
]
const caseLevel = [
    {
        id: 1,
        levelName: '一级',
    },
    {
        id: 2,
        levelName: '二级',
    },
    {
        id: 3,
        levelName: '三级',
    },
    {
        id: 4,
        levelName: '四级',
    },
    {
        id: 5,
        levelName: '五级',
    },
    {
        id: 6,
        levelName: '六级',
    }
]
const num = 10
const url = 'https://image.znzgo.com/cover/fc6a3dc71a344cfeb96a909a1be269c6.jpg?x-oss-process=image/auto-orient,1/resize,m_fill,w_748,h_566,limit_0/quality,q_100/format,webp'


//  子组件模态框
const EditModal = () => {
    const { state: { isModalVisible, info }, dispatch } = useContext(Ctx);

    const [modalClassifyList, setModalClassifyList] = useState([])
    const [options, setOptions] = useState([])
    const [chooseClassifyIdArr, setChooseClassifyIdArr] = useState([])
    const [cascaderValue, setCascaderValue] = useState([])
    const [showChooseList, setShowChooseList] = useState([])
    const [chooseListId, setChooseListId] = useState([])
    const [classifyIdList, setClassifyIdList] = useState([])
    const [coverImg, setCoverImg] = useState('')
    const [imgList, setImgList] = useState([])
    const [showImgUrl, setShowImgUrl] = useState('')
    const [showBigImg, setShowBigImg] = useState(false)
    const [editorClassifyList, setEditorClassifyList] = useState([])
    const [editorClassifyId, setEditorClassifyId] = useState([])
    // 删除 取消图片批量删除所需变量等
    const [isDeleteImgArr, setIsDeleteImgArr] = useState([])//存储批量删除的id数组
    // 等级选择所需变量
    const [levelValue, setLevelValue] = useState('')
    // 风格数据所需变量
    const [styleList, setStyleList] = useState([])
    const [styleValue, setStyleValue] = useState([])//选中的风格数组id
    const [styleIdList, setStyleIdList] = useState([])//最终提交的风格数组id
    const [showChooseStyleList, setShowChooseStyleList] = useState([])
    const [editorStyleList, setEditorStyleList] = useState([])//编辑后获取已有的风格列表
    const [editorStyleIdList, setEditorStyleIdList] = useState([])//编辑后获取已有的风格列表

    // 编辑详情国家列表接口数据
    const [countryValue, setCountryValue] = useState('')
    const [nationCountryList, setNationCountryList] = useState([])//编辑后获取国家列表数据

    // 设计师数据所需变量
    const [desingerList, setDesingerList] = useState([])
    const [desingerValue, setDesingerValue] = useState()
    const [editorDesingerIdList, setEditorDesingerIdList] = useState([])//最终提交设计师id数组
    const [editorDesingerList, setEditorDesingerList] = useState([])//编辑获取已有的设计师列表
    const [chooseDesingerIdList, setChooseDesingerIdList] = useState([])//最终提交后选择的设计师id数组
    const [showChooseDesingerList, setShowChooseDesingerList] = useState([])//选中的设计师展示列表

    const update = useUpdate(); //删除图片强制更新
    useEffect(() => {
        console.log('editorDesingerList======', editorDesingerList)
        console.log('showChooseDesingerList======', showChooseDesingerList)

    }, [editorDesingerList, showChooseDesingerList])
    // 实时查看已选分类的id数组集合
    // useEffect(() => {
    //     console.log('chooseListId======', chooseListId)
    // }, [chooseListId])
    // useEffect(() => {
    //     console.log('editorClassifyId======', editorClassifyId)
    // }, [editorClassifyId])
    // 已有一二级分类传入子组件数据格式修改触发
    useEffect(() => {
        if (info.classifyList.length > 0) {
            handleClassifyList(info.classifyList)
            setModalClassifyList(info.classifyList)
            console.log(info.classifyList)
        }
    }, [info.classifyList])

    // 风格数据的监听处理
    useEffect(() => {
        if (info.styleList.length > 0) {
            setStyleList(info.styleList)
        }
    }, [info.styleList.length > 0])

    // 设计师下拉框数据的监听处理
    useEffect(() => {
        if (info.desingerList.length > 0) {
            setDesingerList(info.desingerList)
        }
    }, [info.desingerList.length > 0])
    // 用户id触发弹窗内图片的更新接口
    useEffect(() => {
        if (info.caseId) {
            setImgList([])
            getImgList()
        }
    }, [info.caseId])

    // 编辑弹窗中分类展示的数组(带一二级分类名称以及二级分类id)  
    useEffect(() => {
        if (showChooseList.length > 0) {
            let addId = []
            showChooseList.forEach(item => {
                addId.push(item.id)
            })
            setChooseListId(addId)
            // 新增后添加已有二级分类的id组合最终提交的二级分类id数组集合
            // setClassifyIdList(addId.concat(editorClassifyId))
        }
    }, [showChooseList])

    // 打开编辑时触发弹窗内的分类更新
    useEffect(() => {
        if (isModalVisible) {
            let classifyIdList = [];
            if (editorClassifyList.length > 0) {
                editorClassifyList.forEach(item => {
                    classifyIdList.push(item.id)
                })
            }
            // setClassifyIdList(classifyIdList)
            setEditorClassifyId(classifyIdList)
        }
    }, [isModalVisible, editorClassifyList])

    // 打开编辑时触发弹窗内的风格更新
    useEffect(() => {
        if (isModalVisible && editorStyleList.length > 0) {
            let editorStyleIdList = [];
            editorStyleList.forEach(item => {
                editorStyleIdList.push(item.styleId)
            })
            // console.log('最终确定修改提交的参数数组是', classifyIdList)
            setEditorStyleIdList(editorStyleIdList)
        } else {
            setEditorStyleIdList([])
        }
    }, [isModalVisible, editorStyleList])

    // 打开编辑时触发弹窗内的设计师更新更新
    useEffect(() => {
        if (isModalVisible && editorDesingerList.length > 0) {
            let editorDesingerIdList = [];
            editorDesingerList.forEach(item => {
                editorDesingerIdList.push(item.propertyId)
            })
            // console.log('最终确定修改提交的参数数组是', classifyIdList)
            setEditorDesingerIdList(editorDesingerIdList)
        } else {
            setEditorDesingerIdList([])
        }
    }, [isModalVisible, editorDesingerList])

    const filter = (inputValue, path) => {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    }
    // 根据caseid获取编辑弹窗中的图片集合
    const getImgList = () => {
        let params = {
            caseId: info.caseId
        }
        queryCaseInfo(params).then(res => {
            if (res?.error?.errorCode == 0) {
                setCoverImg(res?.data?.cases?.cover)
                setImgList(res?.data?.caseContentList)
                setNationCountryList(res?.data?.nationCountryList)
                setCountryValue(res?.data?.cases?.country)
                setEditorClassifyList(res?.data?.caseClassifyDTOList)
                let caseLevel = (res?.data?.caseLevel != null) ? res?.data?.caseLevel.caseLevel : ''
                setLevelValue(caseLevel)// 已有等級赋值编辑框中
                let caseStyleContents = (res?.data?.caseStyleContents != null) ? res?.data?.caseStyleContents : []
                setEditorStyleList(caseStyleContents)
                let designMasterVoList = (res?.data?.designMasterVoList != null) ? res?.data?.designMasterVoList : []
                setEditorDesingerList(designMasterVoList)
            } else {
                message.error(res?.error?.errorMsg)
            }
        })
    }
    // 级联选择器选中时间
    const onChange = (value) => {
        setCascaderValue(value)
    }
    // 点击添加 增加分类到下方框中
    const addChoose = () => {
        console.log(cascaderValue)
        if (cascaderValue.length > 0) {
            let arr = chooseClassifyIdArr;
            // 去重
            if (chooseListId.includes(cascaderValue[cascaderValue.length - 1]) || editorClassifyId.includes(cascaderValue[cascaderValue.length - 1])) {
                message.error('您已添加该分类')
            } else {
                arr.push(cascaderValue)
                setChooseClassifyIdArr(arr);
                handleClassifyNameList(arr);
            }
        } else {
            message.error('请选择分类')
        }

    }
    //  点击添加 增加风格到下方框中
    const addStyle = () => {
        if (styleValue.length > 0) {
            let arr = [...styleIdList];
            let hasIdArr = styleValue.filter(item => styleIdList.concat(editorStyleIdList).indexOf(item) > -1)
            console.log(hasIdArr)
            console.log(styleIdList.concat(editorStyleIdList))
            // 去重
            if (hasIdArr.length > 0) {
                message.error('您已添加某个风格')
            } else {
                arr = arr.concat(styleValue)
                setStyleIdList(arr)
                handleStyleNameList(arr);
            }
        } else {
            message.error('请选择风格')
        }
    }
    //  点击添加 增加设计师到下方框中
    const addDesinger = () => {
        if (desingerValue) {
            //  添加手动选择的设计师ID到数组中
            let arr = [...chooseDesingerIdList]
            let hasIdArr = showChooseDesingerList.concat(editorDesingerList).filter(item => item.propertyId == desingerValue)
            // 去重
            if (hasIdArr.length > 0) {
                message.error('您已添加该设计师')
            } else {
                //存入手动选择的id
                arr.push(desingerValue)
                setChooseDesingerIdList(arr)
                handleDesingerNameList(arr)
            }
        }
    }
    //  处理级联选择器内部数据格式
    const handleClassifyList = (modalClassifyList) => {
        let arr = []
        modalClassifyList.forEach(item => {
            let obj = {
                value: '',
                label: '',
                children: [

                ],
            }
            obj.value = item.id;
            obj.label = item.name;
            item.secondClassifies.forEach((childItem, index) => {
                obj.children.push({
                    value: childItem.id,
                    label: childItem.name,
                    children: []
                })
                childItem.thirdClassifies.forEach(thirdItem => {
                    obj.children[index].children.push({
                        value: thirdItem.id,
                        label: thirdItem.name
                    })
                });
            })
            arr.push(obj)
        });
        setOptions(arr)
    }
    //  处理添加后的分类名称显示
    const handleClassifyNameList = (arr) => {
        console.log(arr)
        if (arr[0].length > 0) {
            let moreShowChooseList = [];
            arr.forEach(item => {
                let obj = {
                    firstName: '',
                    secondName: '',
                    thirdName: '',
                    id: ''
                }
                console.log('modalClassifyList', modalClassifyList)
                let filterFirstArr = modalClassifyList.filter(tem => tem.id == item[0])
                console.log('filterFirstArr', filterFirstArr)
                if (filterFirstArr.length > 0) {
                    obj.firstName = filterFirstArr[0].name;
                    if (item.length > 1) {
                        let filterSecondArr = filterFirstArr[0].secondClassifies.filter(tem => tem.id == item[1])
                        obj.secondName = filterSecondArr[0].name;
                    }
                    if (item.length > 2) {
                        let filterSecondArr = filterFirstArr[0].secondClassifies.filter(tem => tem.id == item[1])
                        obj.secondName = filterSecondArr[0].name;
                        let filterThridArr = filterSecondArr[0].thirdClassifies.filter(tem => tem.id == item[2])
                        obj.thirdName = filterThridArr[0].name;
                    }
                    obj.id = item[item.length - 1];
                    moreShowChooseList.push(obj);
                }

            })
            console.log(moreShowChooseList)
            setShowChooseList(moreShowChooseList)
        }

    }
    //  处理添加后的风格名称显示
    const handleStyleNameList = (arr) => {
        if (arr.length > 0) {
            let showChooseStyleList = [];
            showChooseStyleList = styleList.filter(item => arr.indexOf(item.id) > -1)
            setShowChooseStyleList(showChooseStyleList)
        }

    }
    //  处理添加后的设计师名称显示
    const handleDesingerNameList = (arr) => {
        if (arr.length > 0) {
            let newArr = [...showChooseDesingerList];
            newArr = desingerList.filter(item => arr.indexOf(item.propertyId) > -1)
            console.log(newArr)
            setShowChooseDesingerList(newArr)
        }

    }

    // 点击X删除默认编辑栏的分类
    const deleteEditorIndex = (index) => {
        let arr = [...editorClassifyList]
        // 删除对应的classifyId
        // let list1 = classifyIdList.filter(item => item != arr[index].id)
        let list2 = editorClassifyId.filter(item => item != arr[index].id)
        // console.log('删除编辑栏内的classifyId还有', list1)
        console.log('删除编辑栏内的editorClassifyId', list2)
        // setClassifyIdList(list1)
        setEditorClassifyId(list2)
        // 删除视图显示
        arr.splice(index, 1);
        setEditorClassifyList(arr)
    }
    // 点击X删除对应新增的分类
    const deleteIndex = (index) => {
        let arr1 = [...showChooseList]
        let arr2 = [...chooseClassifyIdArr]
        // 删除对应的classifyId
        let list = chooseListId.filter(item => item != arr1[index].id)
        // console.log('删除后的数组是', list)
        setChooseListId(list)
        arr1.splice(index, 1);
        arr2.splice(index, 1);
        setShowChooseList(arr1)
        setChooseClassifyIdArr(arr2)
    }
    // 点击X删除编辑栏已存在的风格列表
    const deleteEditorStyleIndex = (deleteId) => {
        let list1 = editorStyleIdList.filter(item => item != deleteId)
        let list2 = editorStyleList.filter(item => item.styleId != deleteId)
        setEditorStyleIdList(list1)
        setEditorStyleList(list2)
    }
    // 点击X删除对应新增的风格
    const deleteStyleIndex = (deleteId) => {
        // 删除对应的classifyId
        let list1 = styleIdList.filter(item => item != deleteId)
        let list2 = showChooseStyleList.filter(item => item.id != deleteId)
        setStyleIdList(list1)
        setShowChooseStyleList(list2)
    }

    // 点击X删除编辑栏已存在的设计师
    const deleteEditorDesingerIndex = (deleteId) => {
        let list1 = editorDesingerIdList.filter(item => item != deleteId)
        let list2 = editorDesingerList.filter(item => item.propertyId != deleteId)
        setEditorDesingerIdList(list1)
        setEditorDesingerList(list2)
    }

    // 点击X删除对应新增的设计师
    const deleteChooseDesingerIndex = (deleteId) => {
        let list1 = chooseDesingerIdList.filter(item => item != deleteId)
        let list2 = showChooseDesingerList.filter(item => item.propertyId != deleteId)
        setChooseDesingerIdList(list1)
        setShowChooseDesingerList(list2)
    }

    // 等级选择
    const handleChangelevel = value => {
        setLevelValue(value);
    };
    // 国家选择
    const handleChangeCountry = (value) => {
        // console.log('我选择的国家是', value)
        setCountryValue(value)
    }

    // 设计师选择选择
    const handleChangeDesinger = (value) => {
        console.log('我选择的设计师是', value)
        setDesingerValue(value)
    }

    // 最终提交
    const confirm = async (type) => {
        let res;

        // 点击确认修改按钮
        if (type == 'confirm') {
            if (info.title == '' && info.title.trim()) {
                message.error('标题不能为空');
                return;
            }
            // console.log('当前的editorClassifyId数组是', editorClassifyId)
            if (chooseListId.length < 1 && editorClassifyId.length < 1) {
                // console.log('当前的editorClassifyId数组是', editorClassifyId)
                message.error('请添加分类');
                return;
            }
            // if (styleIdList.concat(editorStyleIdList).length < 1) {
            //     message.error('请添加风格');
            //     return;
            // }
            if (levelValue == '') {
                message.error('请选择等级');
                return;
            }
            // console.log('最终提交的风格数组id是', styleIdList.concat(editorStyleIdList))
            // console.log('最终提交的分类数组id是', chooseListId.concat(editorClassifyId))
            let params = {
                caseId: info.caseId,
                caseLevel: levelValue,
                caseStyleIdList: styleIdList.concat(editorStyleIdList),
                classifyIdList: chooseListId.concat(editorClassifyId),
                designMasterPropertyList: editorDesingerIdList.concat(chooseDesingerIdList),
                title: info.title.replace(/^\s+|\s+$/g, ""),
                country: countryValue ? countryValue : ''
            }
            // console.log(params)
            //调确认修改接口
            res = await dealRelInfo(params);
        } else {
            //调确认下架
            res = await deleteBatch([info.caseId]);
        }

        if (res?.error?.errorCode == 0) {
            dispatch({ isModalVisible: false, success: true });//关闭弹窗刷新列表
            if (type == 'confirm') {
                deleteCaseImgMethod();
                getImgList()
                info.caseId = ''
                message.success('已修改')
            } else {
                message.success('已下架')
            }
            setShowChooseList([])
            setCascaderValue([])
            setEditorClassifyId([])
            setChooseListId([])
            setChooseClassifyIdArr([])
            setShowChooseStyleList([])//弹窗关闭清空用户已添加的风格显示数组
            setStyleValue([])//弹窗关闭清空用户已选择的风格id数组（未点击添加）
            setStyleIdList([])//弹窗关闭清空用户已选择的风格最终提交id数组（已添加）
            setLevelValue([])//清空等级
            setChooseDesingerIdList([])
            setShowChooseDesingerList([])
            setEditorDesingerIdList([])
            setEditorDesingerList([])
            setDesingerValue('')
        } else {
            message.error(res?.error?.errorMsg);
        }
    }
    const handleCancel = () => {
        dispatch({ isModalVisible: false });
        setChooseClassifyIdArr([])
        setCascaderValue([])
        setChooseListId([])//弹窗关闭后清除默认新添加的id
        setShowChooseList([])
        setIsDeleteImgArr([])//弹窗关闭清空用户已选中删除的图片集合
        setShowChooseStyleList([])//弹窗关闭清空用户已添加的风格显示数组
        setStyleValue([])//弹窗关闭清空用户已选择的风格id数组（未点击添加）
        setStyleIdList([])//弹窗关闭清空用户已选择的风格最终提交id数组（已添加）
        setDesingerValue('')
        setChooseDesingerIdList([])
        setShowChooseDesingerList([])
        setEditorDesingerIdList([])
        setEditorDesingerList([])
        info.caseId = ''
    };
    //  打开新的弹窗查看图片
    const checkBigImg = (imgUrl) => {
        setShowBigImg(true)
        setShowImgUrl(imgUrl)
    }
    const handleImgCancel = () => {
        setShowBigImg(false)
    }
    useEffect(() => {
        if (isDeleteImgArr.length > 0) {
            // console.log(isDeleteImgArr)
        }
    }, [isDeleteImgArr])

    // 删除单个图片存入数组
    const deleteItem = (id) => {
        let arr = [...isDeleteImgArr];
        if (!arr.includes(id)) {
            arr.push(id)
        }
        setIsDeleteImgArr(arr)
    }

    // 取消删除单个图片从数组中剔除
    const cancelItem = (id) => {
        let arr = [...isDeleteImgArr];
        arr = arr.filter(item => item !== id)
        setIsDeleteImgArr(arr)
    }

    // 批量删除操作 删除用户已选择的所有图片
    const deleteCaseImgMethod = () => {
        if (isDeleteImgArr.length > 0) {
            let params = {
                caseId: info.caseId,
                caseContentIds: isDeleteImgArr
            }
            deleteCaseImg(params).then(res => {
                if (res?.error?.errorCode == 0) {
                    setIsDeleteImgArr([])
                } else {
                    message.error(res?.error?.errorMsg)
                }
            })
        }

    }
    // 风格多选change获取id数组
    const handleChangeStyleVal = (value) => {
        console.log(value);
        setStyleValue(value)
    }
    return (
        <div>
            <Modal width='1000px' visible={isModalVisible} wrapClassName='classify_modal' onCancel={handleCancel} title={info.headTitle} footer={[
                <Button key="submit" type="primary" onClick={() => confirm('confirm')}>
                    确认
                </Button>, <Button key="submit" type="primary" onClick={() => confirm('soldOut')}>
                    下架
                </Button>
            ]}>
                {

                    <>
                        <div className='imgList'>
                            <div>
                                <img src={coverImg} onClick={() => checkBigImg(coverImg)} alt="" />
                                <span>封面图</span>
                            </div>
                            {
                                imgList.length > 0 ? imgList.map((item) => {
                                    return (isDelete ? <></> :
                                        <div>
                                            <img src={item.imgUrl} onClick={() => checkBigImg(item.imgUrl)} alt="" />

                                            {
                                                (isDeleteImgArr.filter(tem => tem == item.id).length > 0) ? <div className='imgModal'></div> : ''
                                            }
                                            {
                                                (isDeleteImgArr.filter(tem => tem == item.id).length > 0) ? <span onClick={() => cancelItem(item.id)}>取消</span> : <span onClick={() => deleteItem(item.id)}>删除</span>
                                            }

                                        </div>
                                    )
                                }) : ''
                            }


                        </div>
                        <div className='content'>
                            <div className='leftAdd'>
                                {/* 分类 */}
                                <div className='form_item'>
                                    <span className='form_item_label'>分类：</span>
                                    <Cascader
                                        showSearch={{ filter }}
                                        value={cascaderValue}
                                        options={options}
                                        placeholder="请选择或输入关键词查询分类"
                                        expandTrigger="hover"
                                        onChange={onChange}
                                    />
                                    <span className='addBtnStyle' onClick={addChoose}>添加</span>
                                </div>
                                <div className='classifyInput'>
                                    <ul>
                                        {
                                            editorClassifyList.length > 0 ? editorClassifyList.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <span>{item.rootName ? item.rootName : ''}</span>
                                                        <span>{item.rootName ? '-' : ''}</span>
                                                        <span>{item.parentName ? item.parentName : ''}</span>
                                                        <span>{item.parentName ? '-' : ''}</span>
                                                        <span>{item.name ? item.name : ''}</span>
                                                        <span onClick={() => deleteEditorIndex(index)}>X</span>
                                                    </li>
                                                )
                                            }) : ''
                                        }
                                        {
                                            showChooseList.length > 0 ? showChooseList.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <span>{item.firstName}</span>
                                                        <span>{item.secondName != '' ? '-' : ''}</span>
                                                        <span>{item.secondName}</span>
                                                        <span>{item.thirdName != '' ? '-' : ''}</span>
                                                        <span>{item.thirdName}</span>
                                                        <span onClick={() => deleteIndex(index)}>X</span>
                                                    </li>
                                                )
                                            }) : ''
                                        }

                                    </ul>
                                </div>

                                {/* 风格 */}
                                <div className='form_item'>
                                    <span className='form_item_label'>风格：</span>
                                    <Select
                                        mode="multiple"
                                        value={styleValue}
                                        allowClear
                                        style={{ width: 231 }}
                                        placeholder="请选择风格"
                                        onChange={handleChangeStyleVal}
                                    >
                                        {
                                            styleList.length > 0 ? styleList.map((item, index) => {
                                                return (
                                                    <Option value={item.id} key={index} label={item.styleValue}>{item.styleValue}</Option>
                                                )
                                            }) : ''
                                        }
                                    </Select>
                                    <span className='addBtnStyle' onClick={addStyle}>添加</span>
                                </div>
                                <div className='classifyInput'>
                                    <ul>
                                        {

                                            editorStyleList.length > 0 ? editorStyleList.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <span>{item.styleValue}</span>
                                                        <span onClick={() => deleteEditorStyleIndex(item.styleId)}>X</span>
                                                    </li>
                                                )
                                            }) : ''
                                        }
                                        {
                                            showChooseStyleList.length > 0 ? showChooseStyleList.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <span>{item.styleValue}</span>
                                                        <span onClick={() => deleteStyleIndex(item.id)}>X</span>
                                                    </li>
                                                )
                                            }) : ''
                                        }

                                    </ul>
                                </div>

                            </div>
                            <div className='middleInput'>
                                <div className='form_item title'>
                                    <span className='form_item_label'>标题&nbsp;&nbsp;：</span>
                                    <Input className='form_item_input' placeholder="请输入标语" value={info.title} onChange={e => dispatch({ info: { ...info, title: e.target.value } })} />
                                    {/* <Button className='form_item_button' type="primary" onClick={deleteCaseImgMethod}>
                                        批量删除图片
                                    </Button> */}
                                </div>
                                <div className='form_item title'>
                                    <span className='form_item_label'>等级&nbsp;&nbsp;：</span>
                                    <Select value={levelValue} style={{ width: 265 }} onChange={handleChangelevel}>
                                        {
                                            caseLevel.length > 0 ? caseLevel.map((item, index) => {
                                                return (
                                                    <Option value={item.id} key={index}>{item.levelName}</Option>
                                                )
                                            }) : ''
                                        }
                                    </Select>
                                </div>
                                <div className='form_item title'>
                                    <span className='form_item_label'>国家&nbsp;&nbsp;：</span>
                                    <Select
                                        showSearch={true}
                                        allowClear
                                        optionFilterProp="children" value={countryValue} style={{ width: 265 }} onChange={handleChangeCountry}
                                    >
                                        {
                                            nationCountryList.length > 0 ? nationCountryList.map((item, index) => {
                                                return (
                                                    <Option value={item.name} key={index}>{item.name}</Option>
                                                )
                                            }) : ''
                                        }
                                    </Select>
                                </div>
                                <div className='form_item title'>
                                    <span className='form_item_label'>设计师&nbsp;&nbsp;：</span>
                                    <Select
                                        showSearch
                                        allowClear
                                        placeholder="请选择或输入关键词查询设计师"
                                        optionFilterProp="children" value={desingerValue} style={{ width: 265 }} onChange={handleChangeDesinger}
                                    >
                                        {
                                            desingerList.length > 0 ? desingerList.map((item, index) => {
                                                return (
                                                    <Option value={item.propertyId} key={index}>{item.name}</Option>
                                                )
                                            }) : ''
                                        }
                                    </Select>
                                    <span className='addBtnStyle' onClick={addDesinger}>添加</span>
                                </div>
                                <div className='desingerInput'>
                                    <ul>
                                        {

                                            editorDesingerList.length > 0 ? editorDesingerList.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <span>{item.name}</span>
                                                        <span onClick={() => deleteEditorDesingerIndex(item.propertyId)}>X</span>
                                                    </li>
                                                )
                                            }) : ''
                                        }
                                        {
                                            showChooseDesingerList.length > 0 ? showChooseDesingerList.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <span>{item.name}</span>
                                                        <span onClick={() => deleteChooseDesingerIndex(item.propertyId)}>X</span>
                                                    </li>
                                                )
                                            }) : ''
                                        }

                                    </ul>
                                </div>
                            </div>
                        </div>



                    </>

                }

            </Modal>
            <Modal width='1200px' height='1000px' visible={showBigImg} wrapClassName='img_modal' onCancel={handleImgCancel} footer={null}>
                <img src={showImgUrl} alt="" />
            </Modal>
        </div>
    )
}
// 父组件 最外层
function ClassifyManage() {
    const [firstClassifyChoose, setfirstClassifyChoose] = useState('');//一级分类默认选中
    const [secondClassifyChoose, setsecondClassifyChoose] = useState(''); // 二级分类默认选中
    const [dateArr, setDateArr] = useState([]);//时间区间
    const [handleDateArr, setHandleDateArr] = useState([]);//时间区间

    const [websiteId, setWebsiteId] = useState('666');//选中的网站id
    const [weisiteList, setWeisiteList] = useState([])
    const [listStatus, setListStatus] = useState('666'); // 状态选中
    const [searchCaseId, setSearchCaseId] = useState(''); // 状态选中

    const [listLoading, setListLoading] = useState(false)
    const [firstClassifyList, setFirstClassifyList] = useState([]);
    const [secondClassifyList, setSecondClassifyList] = useState([]);

    const [searchId, setSearchId] = useState('');
    const [timer, setTimer] = useState(null);//发布时间
    const [handleTimer, setHandleTimer] = useState(null);//处理时间
    const [tableList, setTableList] = useState([]);
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(20)
    const [total, setTotal] = useState(0)
    const [state, dispatch] = useReducer(reducer, {
        isModalVisible: false, info: initInfo, success: false
    });


    useEffect(() => {
        // 获取网站下拉框数据
        getWebsiteList()
        // 获取一级分类列表
        getFirstClassifyList()
        // 获取子弹窗中风格列表
        getStyleList()
        // 获取子弹窗中风格列表
        getDesingerList()

    }, [])
    useEffect(() => {
        if (state.success) {
            getDataList(searchId, page);
            dispatch({ success: false })
        }
    }, [state.success]);

    useEffect(() => {
        if (firstClassifyChoose == '') {
            setSecondClassifyList([])
        }
    }, [firstClassifyChoose])
    const columns = [
        {
            title: "序号",
            width: '8%',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: 'CASE_ID',
            dataIndex: 'caseId',
            width: '8%',
        },
        {
            title: '分类',
            dataIndex: 'classifyList',
            width: '12%',
            render: (v) => {
                return (
                    <div className="classifyStyle">
                        {
                            v.map((item, i) => {
                                return (
                                    <>
                                        {/* 去除最后一位逗号 */}
                                        {`${item.rootName ? item.rootName : ''}${item.rootName ? '-' : ''}${item.parentName ? item.parentName : ''}${item.parentName ? '-' : ''}${item.name}${(v.length - 1) != i ? ',' : ''}`}
                                    </>
                                )
                            })
                        }
                    </div>
                )
            }
        },
        {
            title: '发布时间',
            dataIndex: 'publishTime',
            width: '12%',
        },
        {
            title: '案例名称',
            dataIndex: 'titleOrigin',
            width: '12%',
            render: (v) => {
                return (
                    <div className="classifyStyle">
                        {v}
                    </div>
                )
            }
        },
        {
            title: '状态',
            dataIndex: 'reviewStatus',
            width: '10%',
            // sorter: (a, b) => a.delStatus > b.delStatus ? 1 : -1,
            render: (v) => {
                return (
                    <span>{recommendStatus[v]}</span>
                )
            }
        },
        {
            title: '处理时间',
            dataIndex: 'reviewTime',
            width: '12%',
        },
        {
            title: '操作',
            dataIndex: '',
            width: '12%',
            render: (v, r) => {
                return (
                    <>
                        <Button onClick={() => modify(r)}>编辑</Button>
                    </>
                )
            },
        }
    ]
    // 编辑带入当前列表的数据填充
    const modify = record => {
        dispatch({
            isModalVisible: true,
            info: {
                ...state.info, caseId: record.caseId,
                headTitle: record.titleOrigin,
                title: record.titleOrigin,
                cover: record.cover,
                editorClassifyList: record.classifyList
            }
        });
    }

    // 获取案例列表 渲染表格
    const getDataList = (classifyId, page) => {
        setListLoading(true)
        let reviewRequest = {
            caseId: searchCaseId,
            classifyId: classifyId,
            endTime: dateArr[1] ? dateArr[1] : '',
            page: page,
            pageSize: pageSize,
            reviewStatus: listStatus,
            startTime: dateArr[0] ? dateArr[0] : '',
            website: websiteId ? websiteId : '',
            reviewStartTime: handleDateArr[0] ? handleDateArr[0] : '',
            reviewEndTime: handleDateArr[1] ? handleDateArr[1] : '',
        }

        if (searchCaseId != '') {
            if (!reg.test(searchCaseId)) {
                message.info('请输入案例数字ID')
                setListLoading(false)
            } else {
                reviewRequest = {
                    caseId: searchCaseId
                }
                setDateArr([])
                setTimer(null)//重置时间区间
                setHandleTimer(null);//重置处理时间
                setListStatus('666')//重置状态下拉框
                setWebsiteId('666')//重置状态下拉框
                setSearchId('');
                setfirstClassifyChoose('');
                setsecondClassifyChoose('');
                getClassiftListMethod(reviewRequest)
            }

        } else {
            if (listStatus == '666') {
                reviewRequest = {
                    classifyId: classifyId,
                    endTime: dateArr[1] ? dateArr[1] : '',
                    page: page,
                    pageSize: pageSize,
                    startTime: dateArr[0] ? dateArr[0] : '',
                    website: websiteId ? websiteId : '',
                    reviewStartTime: handleDateArr[0] ? handleDateArr[0] : '',
                    reviewEndTime: handleDateArr[1] ? handleDateArr[1] : '',
                }
            }
            if (websiteId == '666') {
                reviewRequest = {
                    classifyId: classifyId,
                    endTime: dateArr[1] ? dateArr[1] : '',
                    page: page,
                    pageSize: pageSize,
                    reviewStatus: listStatus,
                    startTime: dateArr[0] ? dateArr[0] : '',
                    reviewStartTime: handleDateArr[0] ? handleDateArr[0] : '',
                    reviewEndTime: handleDateArr[1] ? handleDateArr[1] : '',
                }
            }
            if (websiteId == '666' && listStatus == '666') {
                reviewRequest = {
                    classifyId: classifyId,
                    endTime: dateArr[1] ? dateArr[1] : '',
                    page: page,
                    pageSize: pageSize,
                    startTime: dateArr[0] ? dateArr[0] : '',
                    reviewStartTime: handleDateArr[0] ? handleDateArr[0] : '',
                    reviewEndTime: handleDateArr[1] ? handleDateArr[1] : '',
                }
            }
            getClassiftListMethod(reviewRequest)
        }

    }
    // 获取table数据方法
    const getClassiftListMethod = (reviewRequest) => {
        classifyCheckList(reviewRequest).then((res) => {
            if (res?.error?.errorCode == 0) {
                if (res?.data?.contents.length > 0) {
                    setTableList(res?.data?.contents)
                    setTotal(res?.data?.total)
                } else {
                    setTableList([])
                    setTotal(0)
                    message.error('暂无数据')
                }

            }
        }).finally(() => {
            setListLoading(false)
        })
    }
    // 获取一级分类下拉框数据
    const getFirstClassifyList = () => {
        classifyList()
            .then((res) => {
                if (res?.error?.errorCode == 0) {
                    setFirstClassifyList(res?.data)
                    // setSecondClassifyList(res?.data[0].secondClassifies)
                    // setfirstClassifyChoose(res?.data[0].id)
                    // setsecondClassifyChoose(res?.data[0].secondClassifies[0].id)
                    dispatch({ info: { ...state.info, firstClassifyChooseName: res?.data[0].name, secondClassifyChooseName: res?.data[0].secondClassifies[0].name, firstClassifyChooseId: res?.data[0].id, secondClassifyChooseId: res?.data[0].secondClassifies[0].id, classifyList: res?.data } });
                    // getDataList(0, res?.data[0].secondClassifies[0].id);//默认初始化调用一次接口
                    getDataList('', 1)
                }
            })
    }
    // 获取风格下拉框数据
    const getStyleList = () => {
        styleList()
            .then((res) => {
                if (res?.error?.errorCode == 0) {
                    dispatch({ info: { ...state.info, styleList: res?.data } });
                }
            })
    }

    // 获取设计师下拉框数据

    const getDesingerList = () => {
        desingerList()
            .then((res) => {
                if (res?.error?.errorCode == 0) {
                    dispatch({ info: { ...state.info, desingerList: res?.data } });
                }
            })
    }

    //  获取来源网站下拉框数据
    const getWebsiteList = () => {
        websiteList().then(res => {
            setWeisiteList(res?.data)
        })
    }
    // 一级分类change
    const handleChangeFirstClassify = value => {
        setSearchId(value);
        setfirstClassifyChoose(value);
        let secondClassifyList = firstClassifyList.filter(item => item.id == value)
        setSecondClassifyList(secondClassifyList[0].secondClassifies)//存储当前二级分类数据
        setsecondClassifyChoose('')
        dispatch({ info: { ...state.info, firstClassifyChooseName: secondClassifyList[0].name, firstClassifyChooseId: value, secondClassifyChooseName: '', secondClassifyChooseId: '' } });

    };
    // 二级分类change
    const handleChangeSecondClassify = value => {
        setSearchId(value);
        setsecondClassifyChoose(value);
        let filterNameArr = secondClassifyList.filter(item => item.id == value)
        dispatch({ info: { ...state.info, secondClassifyChooseName: filterNameArr[0].name, secondClassifyChooseId: value } });
    };

    //  状态筛选 
    const handleChangeStatus = value => {
        setListStatus(value)
    }
    //  来源网站筛选 
    const handleChangeWebsite = value => {
        setWebsiteId(value)
    }
    //  发布时间筛选 
    const handleChangePublishTime = (value, dateArr) => {
        setTimer(value)
        let timeArr = [...dateArr];
        timeArr[0] = timeArr[0].replace(/\//g, '-')
        timeArr[1] = timeArr[1].replace(/\//g, '-')
        setDateArr(timeArr)//替换 / 为 -  重新赋值
    }
    //  处理时间筛选 
    const handleChangeHandleTime = (value, dateArr) => {
        setHandleTimer(value)
        let timeArr = [...dateArr];
        timeArr[0] = timeArr[0].replace(/\//g, '-')
        timeArr[1] = timeArr[1].replace(/\//g, '-')
        setHandleDateArr(timeArr)//替换 / 为 -  重新赋值
    }

    // 查询
    const searchList = () => {
        setPage(1)
        getDataList(searchId, 1)
    }
    // 重置选项
    const resetData = () => {
        setDateArr([])
        setTimer(null)//重置时间区间
        setHandleTimer(null)//重置处理时间筛选
        setHandleDateArr([])//重置处理时间存入数组
        setListStatus('666')//重置状态下拉框
        setWebsiteId('666')//重置状态下拉框
        setSearchId('');
        setfirstClassifyChoose('');
        setsecondClassifyChoose('');
        setSearchCaseId('')
        setPage(1)
        state.success = true;
    }

    return (
        <div className="classifyManage">
            <div className="topForm">
                <h2>案例分类审核</h2>
                <div className="myForm">
                    <div>
                        <span className="select_label">一级分类：</span>
                        <Select value={firstClassifyChoose} style={{ width: 120 }} onChange={handleChangeFirstClassify}>
                            {
                                firstClassifyList.length > 0 ? firstClassifyList.map((item, index) => {
                                    return (
                                        <Option value={item.id} key={index}>{item.name}</Option>
                                    )
                                }) : ''
                            }
                        </Select>
                    </div>
                    <div>
                        <span className="select_label">二级分类：</span>
                        <Select value={secondClassifyChoose} style={{ width: 120 }} onChange={handleChangeSecondClassify}>
                            {
                                secondClassifyList.length > 0 ? secondClassifyList.map((item, index) => {
                                    return (
                                        <Option value={item.id} key={index}>{item.name}</Option>
                                    )
                                }) : ''
                            }
                        </Select>
                    </div>
                    <div>
                        <span className="select_label">状态：</span>
                        <Select value={listStatus} style={{ width: 120 }} onChange={handleChangeStatus}>
                            {
                                listStatusArr.length > 0 ? listStatusArr.map((item, index) => {
                                    return (
                                        <Option value={item.type} key={index}>{item.statusName}</Option>
                                    )
                                }) : ''
                            }
                        </Select>
                    </div>
                    <div>
                        <span className="select_label">来源网站：</span>
                        <Select value={websiteId} style={{ width: 120 }} onChange={handleChangeWebsite}>
                            <Option value={'666'} key={'666'}>全部</Option>
                            {
                                weisiteList.length > 0 ? weisiteList.map((item, index) => {
                                    return (
                                        <Option value={item.id} key={index}>{item.websiteName}</Option>
                                    )
                                }) : ''
                            }
                        </Select>
                    </div>
                    <div>
                        <span className="select_label">案例ID：</span>
                        <Input type={Number} style={{ width: 125 }} placeholder="请输入案例ID" value={searchCaseId} onChange={(e) => {
                            setSearchCaseId(e.target.value)
                        }} />
                    </div>
                    <div>
                        <span className="select_label">发布时间：</span>
                        <RangePicker
                            value={timer}
                            showTime={{ format: 'HH:mm:ss' }}
                            format="YYYY/MM/DD HH:mm:ss"
                            onChange={handleChangePublishTime}
                        />
                        {/* <Select value={secondClassifyChoose} style={{ width: 120 }} onChange={handleChangePublishTime}>
                            {
                                secondClassifyList.length > 0 ? secondClassifyList.map((item, index) => {
                                    return (
                                        <Option value={item.id} key={index}>{item.name}</Option>
                                    )
                                }) : ''
                            }
                        </Select> */}
                    </div>
                    <div>
                        <span className="select_label">处理时间：</span>
                        <RangePicker
                            value={handleTimer}
                            showTime={{ format: 'HH:mm:ss' }}
                            format="YYYY/MM/DD HH:mm:ss"
                            onChange={handleChangeHandleTime}
                        />
                    </div>
                    <div>
                        {/* <Button type="primary" onClick={search}>查询</Button> */}
                        <Button type="primary" onClick={searchList}>查询</Button>
                        <Button type="primary" onClick={resetData}>重置</Button>
                    </div>
                </div>

            </div>
            <div className="bottomTable">
                <Table
                    loading={listLoading}
                    columns={columns}
                    dataSource={tableList}
                    pagination={
                        {
                            total: total,
                            current: page,
                            onChange(page) {
                                setPage(page)
                                getDataList(searchId, page)
                            },
                            pageSize: pageSize
                        }
                    }
                />
            </div>
            <Ctx.Provider value={{ state, dispatch }} >
                <EditModal isModalVisible={state.isModalVisible} />
            </Ctx.Provider>
        </div >
    )
}

export default ClassifyManage;